import serverData from './server-data'

const features = serverData.features

const hasFeature = (featureName: string) => {
  return !!features?.[featureName]
}

export const isGroupCreationEnabled = () => {
  return hasFeature('groupsExperience')
}

export const isCoverOnCreateFlowEnabled = () => {
  return hasFeature('isCoverOnCreateFlowEnabled')
}

export const isDetailsV1Dot1Enabled = () => {
  return (
    isCoverOnCreateFlowEnabled() ||
    (!serverData?.user && hasFeature('isCoverOnCreateFlowGuestEnabled'))
  )
}
